var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4745 12.3109C17.5966 14.3615 14.3039 15.5265 12.562 17.8527V30.7149C12.562 32.6405 11.1839 32.1848 11.3125 33.3498L18.9269 28.3739V14.9862L28.783 7.88999L28.2722 7.66949C25.7255 8.71317 23.1273 6.53762 20.1874 6.73239C16.0209 6.89599 12.0722 8.63651 9.14062 11.6016C12.121 10.2824 16.8763 9.99939 19.4745 12.3109Z",
    fill: "#0C1862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3225 21.3328V14.3505C33.3842 15.8205 35.2767 20.3406 31.3225 21.3328ZM32.0575 36.0692L31.3225 35.6393V24.824C32.1604 24.8497 32.6786 25.8456 32.6528 26.8305C32.6528 26.8305 32.7153 34.4486 32.7153 35.1652C32.718 35.3621 32.6592 35.5549 32.5473 35.7169C32.4353 35.8789 32.2757 36.0021 32.0906 36.0692H32.0575ZM33.035 22.7771C35.24 21.1858 38.0219 19.8371 39.6499 17.5036C41.1198 15.2472 37.0039 10.6976 34.8982 7.43799L33.0828 6.96393L20.6359 15.8462V30.9795C20.6359 32.8169 19.6584 32.2914 19.7098 33.3057L27.5594 28.0689V13.1231L29.6504 11.5723V34.9961L25.4317 33.8937C19.5738 33.1587 14.1828 35.8083 10.8496 39.9168C16.2407 37.4142 23.3443 38.0353 28.2944 41.3868L39.1464 33.7246C40.8736 32.0893 39.841 29.1273 39.8814 27.0289C39.5617 23.5157 35.556 23.2842 33.002 22.7771",
    fill: "#0C1862"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/chile.80157579bc658cfcf726ad2f81006326.svg";
export { ForwardRef as ReactComponent };